import { render, staticRenderFns } from "./poll-edit.vue?vue&type=template&id=b4b448c8"
import script from "./poll-edit.vue?vue&type=script&lang=js"
export * from "./poll-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports